export default __webpack_public_path__ + "46382368240cc8d79991ae9fed43a229.png";